module.exports = __webpack_public_path__ + "0451848b7be4b822e9a582fb5c0cdb91.png";